<template>
    <div>
        <v-img :src="single.images[1].url" class="tw-shadow-lg tw-rounded-md tw-border tw-border-gray-900" aspect-ratio="1">
            <div v-if="!preSave" class="tw-w-full tw-h-full tw-absolute tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider" :class="{'tw-opacity-100': hover, 'tw-opacity-0': !hover}" @mouseleave="hover = false" @mouseover="hover = true" style="background:rgba(0,0,0,0.6)">
                <inertia-link :href="tenant ? `/single/${single.id}` : `/single/${artist.artista_url}/${single.id}`">
                    <v-btn class="ma-2" outlined large fab color="white">
                        <v-icon>fas fa-play</v-icon>
                    </v-btn>
                </inertia-link>
            </div>
            <div v-else class="tw-w-full tw-h-full tw-absolute tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider" :class="{'tw-opacity-100': hover, 'tw-opacity-0': !hover}" @mouseleave="hover = false" @mouseover="hover = true" style="background:rgba(0,0,0,0.6)">
                <inertia-link :href="tenant ? `/single/${single.id}` : `/single/${artist.artista_url}/${single.id}`">
                    <v-btn class="ma-2 tw-font-sans" outlined large color="white">
                        Pré-Save
                    </v-btn>
                </inertia-link>
            </div>
        </v-img>
        <inertia-link :href="tenant ? `/single/${single.id}` : `/single/${artist.artista_url}/${single.id}`" class="tw-font-sans tw-text-white tw-font-semibold tw-p-0 tw-truncate tw-text-base tw-mt-2 tw-block tw-text-center tw-pb-5">{{single.name}}</inertia-link>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['single', 'artist', 'spotifyArtist', 'header'],
    data() {
        return{
            hover: false,
        }
    },
    computed: {
        preSave(){
            const release_date = moment(this.single.release_date);
            const today = moment();
            if(release_date > today) return true
            return false; 
        },
    },
    mounted(){
    }
}
</script>

<style>

</style>